import type { ClaimsData } from "@/types";

export enum ClaimSource {
  CALCULATED = "calculated",
  REPORTED = "reported",
  NONE = "none",
}

/** Determines the effective claims data source based on authority and data availability. */
export const getClaimsSource = (claims?: ClaimsData): ClaimSource => {
  if (!claims) return ClaimSource.NONE;
  if (claims.authority === ClaimSource.REPORTED && claims.reported) return ClaimSource.REPORTED;
  if (claims.calculated) return ClaimSource.CALCULATED;
  if (claims.reported) return ClaimSource.REPORTED;
  return ClaimSource.NONE;
};
